import { PrimecapUtils } from 'src/app/utils/primecap-utils';

export abstract class CalculaValorProgress {

  private static porcentagemMinima: number;
  private static porcentagemValorCaptado: number;
  private static porcentagemOverfunding: number;

  public static calcular(
    valorRodadaInvestimento: number,
    valorCaptadoRodadaInvestimento: number,
    valorMinimoSucessoRodadaInvestimento: number
  ): number[]{

    this.calcularPocentagemValorCaptado(
      valorCaptadoRodadaInvestimento,
      valorRodadaInvestimento
    );

    this.calcularPorcentagemMinima(
      valorCaptadoRodadaInvestimento,
      valorRodadaInvestimento,
      valorMinimoSucessoRodadaInvestimento
    );

    this.calcularPorcentagemOverfunding(
      valorCaptadoRodadaInvestimento,
      valorRodadaInvestimento
    );

    return [this.porcentagemMinima, this.porcentagemValorCaptado, this.porcentagemOverfunding];
  }

  private static calcularPocentagemValorCaptado(valorCaptadoRodadaInvestimento: number, valorRodadaInvestimento: number): void {
    this.porcentagemValorCaptado = PrimecapUtils.transformarValorEmPorcentagem(valorCaptadoRodadaInvestimento, valorRodadaInvestimento)
  }

  private static calcularPorcentagemMinima(
    valorCaptadoRodadaInvestimento: number,
    valorRodadaInvestimento: number,
    valorMinimoSucessoRodadaInvestimento: number): void
  {
    if(valorCaptadoRodadaInvestimento > valorRodadaInvestimento){
      this.porcentagemMinima = 0;
    } else if(valorCaptadoRodadaInvestimento > 0){
      this.porcentagemMinima = PrimecapUtils.transformarValorEmPorcentagem(valorMinimoSucessoRodadaInvestimento, valorRodadaInvestimento)
      // this.porcentagemMinima -= this.porcentagemValorCaptado;
    }
  }

  private static calcularPorcentagemOverfunding(
    valorCaptadoRodadaInvestimento: number,
    valorRodadaInvestimento: number): void {
    if (valorCaptadoRodadaInvestimento > valorRodadaInvestimento) {
      let valorOverfunding: number = valorCaptadoRodadaInvestimento - valorRodadaInvestimento;
      this.porcentagemOverfunding = PrimecapUtils.transformarValorEmPorcentagem(valorOverfunding, valorRodadaInvestimento);
    }
  }
}
